import React from "react";
import { SafetyCertificateFilled, ShopFilled } from "@ant-design/icons";
import { BookSharp, Business, Chat, LibraryAdd, MapSharp, Psychology } from "@mui/icons-material";
import TrainingLibrary from "PlatForms/OrgLMS/Dashboards/Admin/TrainingLibrary";
import Trainings from "PlatForms/OrgLMS/Dashboards/Admin/Trainings/training";
import StartChat from "PlatForms/Dashboards/Chat/Chat";
import ChatBadge from "PlatForms/Dashboards/Chat/ChatBadges/ChatBadge";
import AdminLandingPage from "PlatForms/OrgLMS/Dashboards/Admin/LandingPage/AdminLandingPage";
import BusinessGroupsMain from "PlatForms/OrgLMS/Dashboards/Admin/BussinessGroup.js";
import TrainingCertificates from "PlatForms/OrgLMS/Dashboards/Admin/TrainingCertificate/TrainingCertificates";
import InviteRoleSelector from "PlatForms/OrgLMS/Dashboards/Admin/InviteUser/InviteCards";
import SkillsInventory from "PlatForms/OrgLMS/Dashboards/Admin/SkillsInventory/SkillsInventory";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "admin-dashboard",
    route: "/admin-dashboard",
    icon: <ShopFilled size="12px" />,
    component: <AdminLandingPage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Library",
    key: "training-library",
    route: "/training-library",
    icon: <LibraryAdd size="12px" />,
    component: <TrainingLibrary />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: <ChatBadge dataKey="message" name="Messaging"  />,
    key: "messaging",
    route: "/messaging",
    icon: <Chat size="12px" />,
    component: <StartChat />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "trainings",
    route: "/trainings",
    icon: <BookSharp size="12px" />,
    component: <Trainings />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Business Groups",
    key: "business-groups",
    route: "/business-groups",
    icon: <Business size="12px" />,
    component: <BusinessGroupsMain />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Certificate",
    key: "training-certificate",
    route: "/training-certificate",
    icon: <SafetyCertificateFilled size="12px" />,
    component: <TrainingCertificates />,
    noCollapse: true,
  },
  
    {
    type: "collapse",
    name: "Invite Employees",
    key: "invite-employees",
    route: "/invite-employees",
    icon: <MapSharp size="12px" />,
    component: <InviteRoleSelector />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Skills Inventory",
    key: "skills-inventory",
    route: "/skills-inventory",
    icon: <Psychology size="12px" />,
    component: <SkillsInventory />,
    noCollapse: true,
  },
];

export default routes;
